import { render } from "./FavoriteSpotDetail.vue?vue&type=template&id=963417d6&scoped=true"
import script from "./FavoriteSpotDetail.vue?vue&type=script&lang=js"
export * from "./FavoriteSpotDetail.vue?vue&type=script&lang=js"

import "./FavoriteSpotDetail.vue?vue&type=style&index=0&id=963417d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963417d6"]])

export default __exports__